import { IconName } from '@sc/data-access-assets';

export interface ActionDialogType {
  iconName?: IconName;
  title: string;
  text: string;
  buttonText: string;
  emoji?: string;
}
